import React from 'react';
import { Section } from './ui/Section';
import { XCircle } from 'lucide-react';
export function ProblemSection() {
  return <div className="bg-white/50 w-full" data-id="element-66">
      <Section className="space-y-16" data-id="element-67">
        <div className="space-y-6" data-id="element-68">
          <h2 className="font-serif text-3xl md:text-4xl text-navy font-bold" data-id="element-69">
            Si te pasa esto, no necesitás más consejos.
          </h2>
          <p className="text-lg text-navy/80 leading-relaxed" data-id="element-70">
            Te pega un pico en el medio de la nada —o en el peor momento
            posible— y de golpe estás tratando de actuar normal mientras por
            dentro estás en modo alarma.
          </p>
          <p className="text-lg text-navy/80 leading-relaxed" data-id="element-71">
            Y encima aparece la segunda parte (la peor):{' '}
            <strong className="text-navy" data-id="element-72">
              la voz que te dice que deberías poder controlarte.
            </strong>
          </p>

          <div className="grid md:grid-cols-3 gap-6 mt-8" data-id="element-73">
            <div className="bg-cream p-6 rounded-xl border border-navy/5" data-id="element-74">
              <p className="font-serif text-xl text-navy mb-2 italic" data-id="element-75">
                "Respirás..."
              </p>
              <p className="text-navy/70" data-id="element-76">pero te mareás.</p>
            </div>
            <div className="bg-cream p-6 rounded-xl border border-navy/5" data-id="element-77">
              <p className="font-serif text-xl text-navy mb-2 italic" data-id="element-78">
                "Meditás..."
              </p>
              <p className="text-navy/70" data-id="element-79">pero no tenés 30 minutos.</p>
            </div>
            <div className="bg-cream p-6 rounded-xl border border-navy/5" data-id="element-80">
              <p className="font-serif text-xl text-navy mb-2 italic" data-id="element-81">
                "Pensás positivo..."
              </p>
              <p className="text-navy/70" data-id="element-82">
                y te da bronca, porque no es un problema de actitud.
              </p>
            </div>
          </div>

          <p className="text-xl font-medium text-navy mt-8 border-l-4 border-terracotta pl-6 py-2" data-id="element-83">
            Lo que necesitás es un protocolo. Uno corto. Uno que puedas hacer
            aunque estés hecho/a pedazos.
          </p>
        </div>

        <div className="space-y-8 pt-8 border-t border-navy/10" data-id="element-84">
          <h3 className="font-serif text-2xl text-navy font-bold" data-id="element-85">
            Por qué las soluciones viejas fallan
          </h3>
          <ul className="space-y-4" data-id="element-86">
            {['Son demasiado largos (sirven en calma, fallan en crisis).', 'Requieren constancia perfecta (y la ansiedad no avisa).', 'Te ponen a pelear con tu mente cuando tu cuerpo está en alarma.', 'Te dejan con culpa: “si sigo ansioso, estoy fallando”.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-87">
                <XCircle className="w-6 h-6 text-terracotta shrink-0 mt-0.5" data-id="element-88" />
                <span className="text-lg text-navy/80" data-id="element-89">{item}</span>
              </li>)}
          </ul>
        </div>
      </Section>
    </div>;
}